import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

if (process.env.NODE_ENV === "production") {
  Vue.use(VueAnalytics, {
    id: "UA-120531271-3",
    router
  });
}
